<template>
    <div>
        <section class="mr-5 ml-5 mt-5 mb-5">
 
                <nav class="level is-mobile">
						<div class="level-left">

                            <div class="level-item     mr-5">
                                   <b-radio v-model="radioSearchParamsPrepareWantModel"
                                        name="name"
                                        :class=" radioSearchParamsPrepareWantModel == 0 ?  'ml-5 has-text-info' :  'ml-5 has-text-grey-lighter'"
                                        native-value="0">
                                        OPD No. :
                                    </b-radio>
                                          <span :class=" radioSearchParamsPrepareWantModel == 0 ?  'ml-5 has-text-info' :  'ml-5 has-text-grey-lighter'"   v-if="opdParamsForSearchPrepareWantModel == null"> N/A</span> 
                                          <span :class=" radioSearchParamsPrepareWantModel == 0 ?  'ml-5 has-text-info' :  'ml-5 has-text-grey-lighter'"   v-else >{{opdParamsForSearchPrepareWantModel.idopd}} / {{opdParamsForSearchPrepareWantModel.name.substring(0,15)}} </span>   
                                          <b-button type="is-success is-light"
                                            :disabled="radioSearchParamsPrepareWantModel != 0 "
                                            class="ml-3"
                                            @click="showSearchOPD"
                                            icon-right="magnify" />
							</div>

                            <div class="level-item has-text-weight-semibold has-text-primary mr-5">
                                <b-radio v-model="radioSearchParamsPrepareWantModel"
                                        name="name"
                                        :class=" radioSearchParamsPrepareWantModel == 1 ?  'ml-5 has-text-info' :  'ml-5 has-text-grey-lighter'"
                                        native-value="1">
                                        Member ID :
                                </b-radio>
                                          <span :class=" radioSearchParamsPrepareWantModel == 1 ?  'ml-5 has-text-info' :  'ml-5 has-text-grey-lighter'"  v-if="memberIDParamsForSearchPrepareWant == null"> N/A</span> 
                                          <span :class=" radioSearchParamsPrepareWantModel == 1 ?  'ml-5 has-text-info' :  'ml-5 has-text-grey-lighter'"  v-else >{{memberIDParamsForSearchPrepareWant.member_id}} / {{memberIDParamsForSearchPrepareWant.name.substring(0,25)}}</span> 
                                          <b-button type="is-success is-light"
                                            class="ml-3"
                                            :disabled="radioSearchParamsPrepareWantModel != 1 "
                                            @click="showSearchMemberPatho(0)"
                                            icon-right="magnify" />  
							</div>



							<div class="level-item has-text-weight-semibold has-text-primary mr-5">
                                เดือนบันทึก items 
							</div>
                   
                            <div class="level-item has-text-primary">
                                <b-datepicker
                                            v-model="dateInvPrepareWantModel"
                                                type="month"
                                                placeholder="Click to select..."
                                                icon="calendar-today"
                                                trap-focus>
                                </b-datepicker>
                            </div>


                            <div class="level-item">
                                <b-button type="is-success is-light" class="mr-3" icon-left="refresh" @click="loadUsedPart">Refresh</b-button>
                            </div>
						</div>


                        <div class="level-right">
                           <div class="level-item">
                                <b-button 
                                   type="is-success is-light" 
                                   class="mr-3" 
                                   icon-left="database-arrow-right-outline" 
                                   :disabled="rowsSelected.length==0"
                                   @click="addPrepareToInvoice">
                                   Add Prepare To Invoice
                                   <span v-if="rowsSelected.length>0"><b-tag rounded type="is-info"> {{rowsSelected.length}} </b-tag></span> 
                                </b-button>
                            </div>



                            <div class="level-item">
                                <b-button 
                                   type="is-danger is-light" 
                                   class="mr-3" 
                                   icon-left="cart" 
                                   :disabled="rowsPrepareToInvoice.length==0"
                                   @click="viewCart">
                                   Cart
                                   <span v-if="rowsPrepareToInvoice.length>0"><b-tag rounded type="is-info"> {{rowsPrepareToInvoice.length}} </b-tag></span> 
                                </b-button>
                            </div>



                        </div>
				</nav>




                <b-table
                                :data="isEmpty ? [] : usedPartResultSearch "
                                bordered
                                 
                                narrowed
                                
                                :loading="isTableLoading"
                                
                                mobile-cards
 
                                
                               default-sort="idpart"

                               :sort-icon="sortIcon"
                               :sort-icon-size="sortIconSize"
                                
                               :default-sort-direction="defaultSortDirection"

                                :row-class="getRowColor"   :checked-rows.sync="rowsSelected"
                                 checkable
                                :is-row-checkable=" isRowCheckable"  


                                 paginated
                                :per-page="perPageTbl1"
                                :current-page.sync="currentPageTbl1"

                                
                                

                            

                        >
                        <b-table-column  label="รหัส" field="idpart" centered  sortable  v-slot="props">
                           <!-- <span v-if=""> <del> {{ props.row.idpart }} </del>  </span>   -->
                           {{ props.row.idpart }} 
                        </b-table-column>   
                        <b-table-column  label="รายการ"  v-slot="props">
                            {{ props.row.descp }} 
                        </b-table-column> 
                        <b-table-column  label="จำนวน" centered v-slot="props">
                            {{ formatStringToCurrency(props.row.amount) }} 
                        </b-table-column> 
                        <b-table-column  label="หน่วยนับ" centered v-slot="props">
                            {{ props.row.unit_part_txt }} 
                        </b-table-column> 

                        <b-table-column  label="ราคา" centered v-slot="props">
                            {{ formatStringToCurrency(props.row.price) }} 
                        </b-table-column> 


                        <b-table-column  label="idlab" centered v-slot="props">
                            {{ props.row.idlab }} 
                        </b-table-column> 

                        <b-table-column  label="Order ID" centered v-slot="props">
                            {{ props.row.idlabnonautomate }} 
                        </b-table-column> 

                        <b-table-column  label="ผู้บันทึก" centered v-slot="props">
                            {{ props.row.user_rec_fn }} 
                        </b-table-column> 


                        <b-table-column  label="บันทึกเมื่อ test" centered v-slot="props">
                            <!-- {{ props.row.dt_rec }}  -->
 
                             <span  :class="props.row.status != -1 ? 'is-size-6' : 'has-text-danger is-size-6' ">
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).date }}  
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).month }} 
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).year }} 
                                 </span> 
                                     


                                 <span  :class="props.row.status != -1 ? 'is-size-7 is-italic' : 'has-text-danger is-size-7 is-italic' "  >
                                     {{  getISO8601ToYearMonthDate( props.row.dt_rec ).hour }}:{{  getISO8601ToYearMonthDate( props.row.dt_rec ).minute }} 
                                 </span>  


                        </b-table-column> 

                        <b-table-column  label="LMID" centered v-slot="props">
                            {{ props.row.member_id }} 
                        </b-table-column> 

                        <b-table-column  label="ชื่อสมาชิก"  field="patho_member_name" centered sortable  v-slot="props">
                            {{ props.row.patho_member_name }} 
                        </b-table-column> 


                        <b-table-column  label="Visit no/Job ID" centered v-slot="props">
                            {{ props.row.visit_no }} 
                        </b-table-column> 
                        <b-table-column  label="opd_no" field="opd_no" centered sortable  v-slot="props">
                            {{ props.row.opd_no }} 
                        </b-table-column> 
                        <b-table-column  label="opd_name" centered v-slot="props">
                            {{ props.row.opd_name }} 
                        </b-table-column> 

                        <b-table-column  label="owner_name" centered v-slot="props">
                            {{ props.row.owner_name }}  {{ props.row.owner_surname }} 
                        </b-table-column> 
                         
                         
                        <b-table-column  label="Invoice" centered v-slot="props">
                            {{ props.row.invoice }} 
                        </b-table-column> 


                        <!-- <b-table-column  label="สถานะ" centered v-slot="props">
                            {{ props.row.status }} 
                        </b-table-column>  -->



                        <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                        </template>



                </b-table>        





        </section>


         <b-modal
                v-if="isSearchOPDForPrepareMakeInvoiceShowing"
                v-model="isSearchOPDForPrepareMakeInvoiceShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SearchOPDForPrepareMakeInvoice v-if="isSearchOPDForPrepareMakeInvoiceShowing"
                     :isShowing="isSearchOPDForPrepareMakeInvoiceShowing"
                     @HNSelected="HNSelected"
                     @close="closeSearchOPDForPrepareMakeInvoice"
                     
            />
     </b-modal>



     <b-modal
                v-if="isSearchMemberPathoShowing"
                v-model="isSearchMemberPathoShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SearchMemberPatho v-if="isSearchMemberPathoShowing"
                     :isShowing="isSearchMemberPathoShowing"
                     :mode="modeSearchMemberPatho"
                     @memberIDSelected_ForSearchParam="memberIDSelected_ForSearchParam"
                     @close="closeSearchMemberPatho"
                     
            />
     </b-modal>



    </div>
</template>



<script>
import { mapActions , mapState , mapMutations  } from 'vuex'
import axios from "axios";
import { getBaseURLforBackEnd , getConfigAxios  } from '@/utils.js'
import _ from 'lodash'


import SearchOPDForPrepareMakeInvoice from './SearchOPDForPrepareMakeInvoice.vue'
import SearchMemberPatho from './SearchMemberPatho.vue'


import formatStringToCurrency from '../../../mixins/methods/formatStringToCurrency'
import getISO8601ToYearMonthDate from '../../../mixins/methods/getISO8601ToYearMonthDate'
 
export default {
    name : "PrepareMakeInvoice_SearchItems",
    components:{
     SearchOPDForPrepareMakeInvoice,
     SearchMemberPatho,
    },
    mixins:[formatStringToCurrency,getISO8601ToYearMonthDate,],
    // updated(){
      
    //    this.$nextTick(function () {
    //             // Code that will run only after the
    //             // entire view has been re-rendered
    //              console.log("updated --> PrepareMakeInvoice_SearchItems")
    //         })
    // },
    mounted(){
		if(this.dateInvPrepareWantModel == null){
            this.loadCurrentDate()
                //  .then(()=>{
                //      if(this.pathoMonthInvManagerArrModel.length==0 &&  this.dateInvManagerWant != null ){
                //         this.fetchPathoMonthInvManager()
                //      }
                //  })
       
        }
	},
    computed:{
        ...mapState({
            access_token : state => state.master_data.access_token ,

            dateInvPrepareWant : state => state.patho_invoice.dateInvPrepareWant ,
            opdParamsForSearchPrepareWant : state => state.patho_invoice.opdParamsForSearchPrepareWant ,
            memberIDParamsForSearchPrepareWant : state => state.patho_invoice.memberIDParamsForSearchPrepareWant ,
            usedPartResultSearch: state => state.patho_invoice.usedPartResultSearch ,
            
            radioSearchParamsPrepareWant: state => state.patho_invoice.radioSearchParamsPrepareWant ,



            memberIDParamsForMakeInvPrepareWant: state => state.patho_invoice.memberIDParamsForMakeInvPrepareWant ,
            rowsPrepareToInvoice: state => state.patho_invoice.rowsPrepareToInvoice ,

		}),

        
        dateInvPrepareWantModel:{
                get: function () {
                    return this.dateInvPrepareWant
                },
                set: function (newValue) {
                    this.setDateInvPrepareWant(newValue)
                }
        },
        opdParamsForSearchPrepareWantModel:{
                get: function () {
                    return this.opdParamsForSearchPrepareWant
                },
                set: function (newValue) {
                    this.setOPDParamsForSearchPrepareWant(newValue)
                }
        },
        memberIDParamsForSearchPrepareWanttModel:{
                get: function () {
                    return this.memberIDParamsForSearchPrepareWant
                },
                set: function (newValue) {
                    this.setMemberIDParamsForSearchPrepareWant(newValue)
                }
        },
        memberIDParamsForMakeInvPrepareWantModel:{
                get: function () {
                    return this.memberIDParamsForMakeInvPrepareWant
                },
                set: function (newValue) {
                    this.setMemberIDParamsForMakeInvPrepareWant(newValue)
                }
        },
        radioSearchParamsPrepareWantModel:{
                get: function () {
                    return this.radioSearchParamsPrepareWant
                },
                set: function (newValue) {
                    this.setRadioSearchParamsPrepareWant(newValue)
                }
        },

        rowsPrepareToInvoiceModel:{
                get: function () {
                    return this.rowsPrepareToInvoice
                },
                set: function (newValue) {
                    this.setRowsPrepareToInvoice(newValue)
                }
        },

    },    
    methods:{
       ...mapMutations({
            setDateInvPrepareWant : 'patho_invoice/setDateInvPrepareWant',
            setOPDParamsForSearchPrepareWant : 'patho_invoice/setOPDParamsForSearchPrepareWant',
            setMemberIDParamsForSearchPrepareWant : 'patho_invoice/setMemberIDParamsForSearchPrepareWant',
            setRadioSearchParamsPrepareWant: 'patho_invoice/setRadioSearchParamsPrepareWant',
            setMemberIDParamsForMakeInvPrepareWant: 'patho_invoice/setMemberIDParamsForMakeInvPrepareWant',
            setRowsPrepareToInvoice: 'patho_invoice/setRowsPrepareToInvoice',
       }), 

       ...mapActions({
                fetchUsedPartPathoFromMonthYear : 'patho_invoice/fetchUsedPartPathoFromMonthYear',
        }),
        viewCart(){
            this.$router.push(`/preparemakeinvoice_cart`)
                        .catch(()=>{});
        },  
        //***************************** */
       
        memberIDSelected_ForSearchParam(payload){
            this.setMemberIDParamsForSearchPrepareWant(payload)
            this.isSearchMemberPathoShowing = false
        },
        closeSearchMemberPatho(){
            this.isSearchMemberPathoShowing = false
        },
        showSearchMemberPatho(_mode){
            this.modeSearchMemberPatho = _mode
            this.isSearchMemberPathoShowing = true
        },

        


        //***************************** */
        HNSelected(_data){
            // console.log(_data)
            this.setOPDParamsForSearchPrepareWant(_data)
            this.isSearchOPDForPrepareMakeInvoiceShowing = false
        },
        closeSearchOPDForPrepareMakeInvoice(){
            this.isSearchOPDForPrepareMakeInvoiceShowing = false
        },
        showSearchOPD(){
            this.isSearchOPDForPrepareMakeInvoiceShowing = true
        },



       
        addPrepareToInvoice(){
            // insert union type
            this.rowsPrepareToInvoiceModel = _.union(this.rowsPrepareToInvoiceModel, this.rowsSelected);


             // clear  this.rowsSelected
             this.rowsSelected = []

             this.$buefy.toast.open({
                    duration: 500,
                    message: `New Record`,
                    position: 'is-top-right',
                    type: 'is-success'
                })
        },
        checkRowInRowsSelected(_idUsedpart){
           return   this.rowsSelected.find(dat=>dat.used_part_patho_id==_idUsedpart) ? true : false
        },
        checkRowInRowPrepareToInvoice(_idUsedpart){
           return   this.rowsPrepareToInvoiceModel.find(dat=>dat.used_part_patho_id==_idUsedpart) ? true : false
        },
        getRowColor(row){
             // console.log(`${row.used_part_patho_id} , checkRowInRowsSelected--> ${this.checkRowInRowsSelected(row.used_part_patho_id)} , checkRowInRowPrepareToInvoice--> ${this.checkRowInRowPrepareToInvoice(row.used_part_patho_id)}`)
             
             if(  row.invoice != null  ){
                return 'is-invoice' 
             }

             
             if( this.checkRowInRowsSelected(row.used_part_patho_id) ){
                return 'is-pass' 
             }

             return  this.checkRowInRowPrepareToInvoice(row.used_part_patho_id) ?  'is-info' :  ''
           
        },  
       isRowCheckable(row){
                // const onhand_in_dept = (row.onhand_in_dept === null )|| (row.onhand_in_dept === "")  ? 0 : parseFloat(row.onhand_in_dept)
                // if ((!(row.needstock && onhand_in_dept===0)) && (row.formula) ){
                //     return row
                // }
              if ( row.invoice == null && !this.checkRowInRowPrepareToInvoice(row.used_part_patho_id) ){
                return row
              }   
              
        },
        
        
       save(){

       },

       loadUsedPart(){


             if(this.radioSearchParamsPrepareWantModel == 0 && this.opdParamsForSearchPrepareWantModel == null ){
                     this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `please select some OPD No.`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                return
             } 
             if(this.radioSearchParamsPrepareWantModel == 1 && this.memberIDParamsForSearchPrepareWanttModel == null){
                     this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `please select some Member ID`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                return 
             }



             this.isTableLoading = true
             this.fetchUsedPartPathoFromMonthYear()
                 .then(()=>{
                     this.isTableLoading = false
                     this.rowsSelected = []
                     //this.rowsPrepareToInvoice = []
                 })
       },


       loadCurrentDate(){
             return new Promise((resolve) => {  
                                            axios.get(`${getBaseURLforBackEnd()}/api/curdatetime` ,getConfigAxios())
                                                .then( (response) => {
                                                            this.dateInvPrepareWantModel = new Date( Date.parse(response.data.current_datetime))    // new Date( Date.parse(response.data.current_datetime)) 
                                                            resolve(response)
                                                        }) 
        })

        },      
    },
    data(){
        return{
            isTableLoading : false,
            activeTab : 0,
            isEmpty : false,

            rowsSelected : [],

           // rowsPrepareToInvoice :[],

            isSearchOPDForPrepareMakeInvoiceShowing : false,
            isSearchMemberPathoShowing: false,

          //  radioSearch : 0,  // 0 --> OPD No, 1 --> Member ID 


         


            defaultSortDirection: 'asc',
            sortIcon: 'arrow-up',
            sortIconSize: 'is-small',

 
            // stickyHeaders: true,
            modeSearchMemberPatho : 0 , // 0 --> search for searchParamsSearchItems , 1 --> search for searchParamsForMakeInv


            perPageTbl1 : 20,
            currentPageTbl1 : 1,

            perPageTbl2 : 20,
            currentPageTbl2 : 1,


        
        }
    } 
}
</script>



<style >
   tr.is-info {
        background: #e4e4dc;
        color: rgb(125, 122, 122);
    }

   tr.is-pass {
        background: #eee0ea;
        color: rgb(68, 54, 54);
    } 

  tr.is-invoice {
        background: #cecbce;
        color: rgb(45, 44, 44);
    } 
    
    
    /* #is-pass {
        background-color: #eee0ea;
        color:  #36142d;
    }

    #is-active {
       background-color: #d4ebdb;
        color: #d4ebdb;
    } */
</style>